import { render, staticRenderFns } from "./totem-preview.vue?vue&type=template&id=25c7c4e0&"
import script from "./totem-preview.vue?vue&type=script&lang=js&"
export * from "./totem-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports